import React from "react";
import CountUp from "react-countup";
import projects, { totalUsers } from "../../../data/data";
import "./TractionBar.css";

function TractionBar() {
  return (
    <section className="traction-bar">
      <div className="traction-glow" />
      <div className="container">
        <div className="traction-total">
          <div className="traction-number">
            <CountUp end={totalUsers} duration={2.5} separator="," enableScrollSpy scrollSpyOnce />+
          </div>
          <span className="traction-caption">
            People using a DLPlatforms product
          </span>
        </div>

        <div className="traction-grid">
          {projects.map((product) => (
            <div key={product.id} className="traction-card">
              <div className="traction-card-value">
                <CountUp
                  end={product.users}
                  duration={2.5}
                  separator=","
                  enableScrollSpy
                  scrollSpyOnce
                />
                +
              </div>
              <span className="traction-card-name">{product.name}</span>
              <span className="traction-card-meta">
                {product.usersNoun} · {product.category}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TractionBar;
